// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { EMRWorklistDayType } from "../../types";
import { getEMRWorklistDay } from "../../api";

export const WORKLIST_DAY_REFRESH_MS = 60_000;

export const useEMRWorklistDay = (
  clinicId: string | undefined,
  connectionId: string | undefined,
  date: string
) => {
  const { getToken } = useTokenAccess();

  return useQuery<EMRWorklistDayType>({
    queryKey: ["emr-worklist-day", clinicId, connectionId, date],
    queryFn: async () => {
      if (!clinicId || !connectionId) throw new Error();
      const token = await getToken();
      return getEMRWorklistDay(token, clinicId, connectionId, date);
    },
    enabled: Boolean(clinicId && connectionId),
    refetchOnWindowFocus: false,
    refetchInterval: WORKLIST_DAY_REFRESH_MS,
    staleTime: 0,
  });
};
